export const supplierValues = [
  'barn',
  'castle',
  'cityHotelCityVenue',
  'conferenceCentre',
  'countryHouseManorHouse',
  'cruiseBoatYacht',
  'gardenOutdoor',
  'golfCourse',
  'hotel',
  'museumAttraction',
  'otherVenueType',
  'placeOfWorship',
  'pubRestaurant',
  'resort',
  'sportingVenueStadium',
  'statelyHome',
  'townHallRegistryOffice',
  'uniqueVenueType',
  'warehouseFactory',
];
export const supplierTypeItems = ['typeDetails.venue.type'];
export const guestsItems = [
  'typeDetails.venue.capacity.dining',
  'typeDetails.venue.capacity.reception',
];
export const bridalSuiteValues = [
  'honeymoonSuite',
  'standardRoom',
  'changingOnly',
  'bridalSuiteNone',
];
export const accommodationItems = [
  'typeDetails.venue.accommodation.rooms',
  'typeDetails.venue.accommodation.people',
  'typeDetails.venue.accommodation.bridalSuite',
];
export const timeTableItems = [
  'typeDetails.venue.time.usualStart',
  'typeDetails.venue.time.usualFinish',
  'typeDetails.venue.time.extension',
];
